export default (value) => {
    let formattedValue = Math.round(parseFloat(value));
    formattedValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(formattedValue);
    return formattedValue;
}

